import React from 'react';
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getApiHeader } from 'utlis/commonfunctions';
import { ToastContainer, toast } from "react-toastify";
import swal from 'sweetalert';
import Modal from 'react-bootstrap/Modal';
import Switch from "@mui/material/Switch";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";
import Checkbox from '@material-ui/core/Checkbox';
import { ThreeDots } from 'react-loader-spinner'

const selectProps = { indeterminate: isIndeterminate => isIndeterminate };



const SERVER_URL = process.env.REACT_APP_API_URL;


const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(1px)",
    zIndex: 9999,
  },
};


function SearchAndReturnSimStock() {
  const [activeTab, setActiveTab] = useState("pageOne")
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [retailerData, setRetailerData] = useState([])
  const [storeData, setStoreData] = useState([])
  const [rememberMe, setRememberMe] = useState(false);
  const [rememberMe1, setRememberMe1] = useState(false);
  const [allocateBox, setAllocateBox] = useState(false);
  const [retailerBox, setRetailerBox] = useState(false);
  const [pid, setPid] = useState("");
  const [retailer_code, setRetailer_code] = useState("");
  const [retailerAddress, setRetailerAddress] = useState("")  
  const [company, setCompany] = useState("")
  const [name, setName] = useState("")
  const [text, setText] = useState(false)
  const [button, setButton] = useState(false)
  const [selectedSimBaseIds, setSelectedSimBaseIds] = useState([]);
  const [seachStore, setSearchStore] = useState(false)
  const [delearDetails, setDelearDetails] = useState(false)
  const [selectedRetailerId, setSelectedRetailerId] = useState(null);
  const [retailerDetails, setRetailerDetails] = useState(false)
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [dataTable, setDataTable] = useState(false)
  const [storeDataTable, setStoreDataTable] = useState(false)

  const [selectedRows, setSelectedRows] = useState(false);
  const [toggledClearRows, setToggleClearRows] = useState(false);
  const [tableView, setTableView] = useState(false);
  const[retailerDetails1,setRetailerDetails1]=useState(false);
  const [disable,setDisable]=useState(false)
  



  const rowsPerPage = 10;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = retailerData.slice(indexOfFirstRow, indexOfLastRow);
  const StoreData = storeData.slice(indexOfFirstRow, indexOfLastRow);
 
  const [formData, setFormData] = useState({
    sim_number: "",
    bundle_number: "",
    control_number: "",
    box_number: "",
    retailer_code: "",
    sim_base_ids: [],
    store_name: "",
    email: "",
    abn: "",
    state: "",
    city: "",
    postcode: "",
    street_name: "",

  });

  
  const handleSearch = async (e) => {
    setLoading(true)
    e.preventDefault();
  
    // Check if sim_base_ids is defined
    if (!formData.sim_base_ids) {
      formData.sim_base_ids = []; 
    }
  
    if (
      formData.sim_number === "" &&
      formData.bundle_number === "" &&
      formData.control_number === "" &&
      formData.box_number === "" &&
      formData.retailer_code === "" &&
      formData.sim_base_ids.length === 0 &&
      formData.store_name === "" &&
      formData.email === "" &&
      formData.abn === "" &&
      formData.state === "" &&
      formData.city === "" &&
      formData.postcode === "" &&
      formData.street_name === ""
    ) {
      toast.error("At least one input field must be filled");
      setLoading(false)
      return;
    }
  
    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) => value !== "" && (!Array.isArray(value) || value.length > 0))
    );
  
    // Check if filteredFormData is empty
    if (Object.keys(filteredFormData).length === 0) {
      toast.error("Please fill in at least one input field for searching");
      setLoading(false)
      return;
    }
  
    const headers = await getApiHeader();
    try {
      const response = await axios.post(`${SERVER_URL}get_old_sim_stock_data`, filteredFormData, {
        headers: headers
      });
      if (response.status === 200) {
        setLoading(false)
        setDisable(true)
        if (response.data.data.sim_bases_data !== null && response.data.data.sim_bases_data.length > 0) {
          setDataTable(true);
          setRetailerData(response.data.data.sim_bases_data);
          toast.success(response.data.message);
          console.log("retailer-data", response.data.data.sim_bases_data);
        } else {
          setDataTable(false);
          setAllocateBox(false);
          setRememberMe(false);
          setRememberMe1(false);
          toast.error("No data found during searching");
        }
        console.log("response", response.data.data);
      }
    } catch (error) {
      setLoading(false)
      setDisable(true)
      console.log(error);
      const errorMessage = error?.response?.data?.message || "An error occurred";
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
            toast.error(message);
          });
        });
      } else {
        toast.error(errorMessage);
      }
    }
  };
  
  

















  const handleAllocate = async (e) => {
    e.preventDefault();
    setLoading(true)
    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) => value !== "")
    );
    const headers = await getApiHeader();
    try {
      const response = await axios.post(`${SERVER_URL}return_sim_stock`, filteredFormData, {
        headers: headers
      });
      if (response.status === 200) {
         setLoading(false)
        const data = response.data.data
        console.log("data", data)
        // toast.success(response?.data?.message);
        const message = response.data.message
        setAllocateBox(false);
        setRetailerDetails1(false)
        setStoreDataTable(false)
        setSelectedRetailerId(null)

      
        setFormData(prevFormData => ({
          ...prevFormData,
          retailer_code:""
        }));
        swal({
          title: "",
          text:  message ,
          icon: "success",
          button: "Close"
        }).then(() => {
          window.location.reload();
        });
      }
      console.log("response", response.data.message);

    } catch (error) {
      setButton(false)
      // setFormData(prevFormData => ({
      //   ...prevFormData,
      //   retailer_code:""
      // }));
      console.log(error)
      setLoading(false)
      const errorMessage = error?.response?.data?.message || "An error occurred";
      swal({
        title: "",
        text: errorMessage,
        icon: "error",
        button: "Close"
      });
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
            // toast.error(message);
          });
        });

      } else {
        setButton(false)
        // toast.error(errorMessage);

      }
    }
  };





  const handleChange = (e) => {
    setDisable(false)
    const { name, value } = e.target;

    if (name === "bundle_number") {
      setFormData({ ...formData, [name]: value });
      if (/^\d{0,20}$/.test(value)) {}
    } else if (name === 'sim_number') {
      if (/^\d{0,20}$/.test(value)) {
        setFormData({ ...formData, [name]: value });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handlePidChange = (e) => {
    const value = e.target.value
    setFormData({
      ...formData,
      retailer_code: value
    });
    setPid(value)

  }



  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < Math.ceil(retailerData.length / rowsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };




  const handleSetRememberMe = (e) => {
    setRememberMe(prevState => {
      const newRememberMeState = !prevState;
      setRetailerBox(newRememberMeState);
      return newRememberMeState;
    });
    setRememberMe1(false);
    setDelearDetails(false);

  };

  const handleSetRememberMe1 = (e) => {
    setRememberMe1(prevState => {
      const newRememberMe1State = !prevState;
      setSearchStore(newRememberMe1State);
      return newRememberMe1State;
    });
    setRememberMe(false);
    setRetailerDetails(false)
    setRetailerDetails1(false)
    setFormData(prevFormData => ({
      ...prevFormData,
      retailer_code: "",
      store_name: "",
      email: "",
      abn: "",
      state: "",
      city: "",
      postcode: "",
      street_name: "",
    }));
  };








  /**    functions for search store */


  const handleBack = () => {
    setSearchStore(false)
    setDelearDetails(false)
    setRetailerBox(false)
    setRetailerDetails1(false)
    setRememberMe1(false)
    setAllocateBox(false)
    setButton(false)

    // setFormData({
    //   sim_number: "",
    //   bundle_number: "",
    //   control_number: "",
    //   box_number: "",
    //   retailer_code: "",
    // })
    handleClear();

  }

  const handleStoreSearch = async (e) => {
    e.preventDefault();
   
    if (
      formData.retailer_code === "" &&
      formData.store_name === "" &&
      formData.email === "" &&
      formData.abn === "" &&
      formData.state === "" &&
      formData.city === "" &&
      formData.postcode === "" &&
      formData.street_name === ""
    ) {
      toast.error("At least one input field must be filled");
      setTableView(false);
      return;
    } else if (formData.street_name && (formData.city === "" && formData.postcode === "")) {
      toast.error("Please enter post code or city name");
      setTableView(false);
      return;
    } else if (formData.state && (formData.city === "" &&formData.postcode === "")) {
      toast.error("Please enter street name or post code");
      setTableView(false);
      return;
    }
    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) => value !== "")
    );
    const headers = await getApiHeader();

    try {
      const response = await axios.post(`${SERVER_URL}search-retailer-store`, filteredFormData, {
        headers: headers
      });
      
      if (response.status === 200) {
        setDisable(true)
        console.log("retailerData", response.data.data)
        console.log("length", response.data.data.length)
        if (response.data.data !== null && response.data.data.length > 0) {
          setCurrentPage(1)
          setStoreDataTable(true)
          setDataTable(false)
          
          setStoreData(response.data.data)
          setRetailerData(response.data.data)
          // setStoreData(response.data.data.search_store_data)
          // setRetailerData(response.data.data.search_store_data)
          toast.success(response.data.message);
        } else {
          setStoreDataTable(false)
          setRetailerBox(false)
          setRememberMe1(false);
          setDelearDetails(false)
          setDelearDetails(false)
          setRetailerAddress("") 
          setCompany("")
          setName("")
          setFormData({
            retailer_code:"",
          })

          toast.error("No data found during searching");
        }
      }

    } catch (error) {
      setDisable(true)
      const errorMessage = error?.response?.data?.message || "An error occurred";
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
            toast.error(message);
          });
        });

      } else {
        toast.error(errorMessage);

      }
    }
  };



  const handleAllocateRetailer = (event, retailer_id) => {
    setAllocateBox(true);
    if (event.target.checked) {
      setSelectedRetailerId(retailer_id);
      setFormData((prevFormData) => ({
        ...prevFormData,
        retailer_code: retailer_id
      }));
      
    } else {
      setSelectedRetailerId(null);
      setFormData((prevFormData) => ({
        ...prevFormData,
        retailer_code: ""
      }));
    }
  };






  const handleCheckAll = (event) => {
    const isChecked = event.target.checked;
    setIsAllChecked(isChecked);
    setAllocateBox(isChecked);

    if (isChecked) {
      const allIds = retailerData
        .filter(data => !data.shop_code)
        .map(data => data.sim_base_id);
      setSelectedSimBaseIds(allIds);
      setFormData(prevFormData => ({
        ...prevFormData,
        sim_base_ids: allIds
      }));
    } else {
      setSelectedSimBaseIds([]);
      setFormData(prevFormData => ({
        ...prevFormData,
        sim_base_ids: []
      }));
      setAllocateBox(false);
    }
  };

  const handleClear = () => {
    setFormData({
    sim_number: "",
    bundle_number: "",
    control_number: "",
    box_number: "",
    retailer_code: "",
    sim_base_ids: [],
    store_name: "",
    email: "",
    abn: "",
    state: "",
    city: "",
    postcode: "",
    street_name: "",
    });
    setStoreDataTable(false)
    setRetailerDetails(false)
    setRetailerDetails1(false)
    setSelectedRetailerId(null)
   
  };

   const handleClear1=()=>{
    setFormData({
      sim_number: "",
      bundle_number: "",
      control_number: "",
      box_number: "",
      retailer_code: "",
    });
      setDataTable(false)
      setAllocateBox(false)
      setRetailerBox(false)
      setDelearDetails(false) 
      setRememberMe(false)
      setButton(false)


   }

  const columns = [

    {
      id: 1,
      name: "Box Number",
      selector: (row) => row.box_number,
    },
    {
      id: 2,
      name: "Bundle Number",
      selector: (row) => row.bundle_number,
    },
    {
      id: 3,
      name: "Control Number",
      selector: (row) => row.control_number,
    },
    {
      id: 4,
      name: "Sim Number",
      selector: (row) => row.sim_number,
    },
    {
      id: 5,
      name: "Channel",
      selector: (row) => row.channel,
    },
    {
      id: 6,
      name: "Retailer ID",
      selector: (row) => row.shop_code ,
    },
    {
      id: 7,
      name: "Retailer Company",
      selector: (row) => row.retailer_company_name,
    },


  ];








  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL"
  };


  const handleChanges = ({ selectedRows }) => {
    const updatedSimBaseIds = selectedRows.map(row => row.sim_base_id);
    setAllocateBox(true);
    setFormData(prevFormData => ({
      ...prevFormData,
      sim_base_ids: updatedSimBaseIds
    }));
    setSelectedRows(selectedRows);
};



  const handleClearRows = () => {
    setToggleClearRows(!toggledClearRows);
  }

  const rowDisabledCriteria = null;



  const customStyles = {
    gyksGC: {
      style: {
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    },
    fKWVwL: {
      style: {
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }

    },
    rows: {
      style: {
        border: '1px solid #ccc', // Add border to rows
      },
    },
    headCells: {
      style: {
        backgroundColor: '#f0f0f0',
        border: '1px solid #ccc', // Add border to header cells
      },
    },
    cells: {
      style: {
        border: '1px solid #ccc', // Add border to individual cells
      },
    },
  };












  return (
    <DashboardLayout>
      <DashboardNavbar />
      <>
      
          <div>

            {loading && (
              <div style={styles.wrapper}>
                <ThreeDots
                  visible={loading}
                  height="80"
                  width="80"
                  color="#C11D6C"
                  radius="9"
                  ariaLabel="three-dots-loading"
                />
              </div>
            )}
            <div className="formbold-main-wrapper">
              <div className="formbold-form-wrapper">
                <h5 style={{ textAlign: "center" }}>Search And Return Old SIM Stock</h5>
                <form action="" method="" onSubmit={handleSearch} autoComplete='off'>
                  <div className="formbold-mb-5 formbold-pt-3">
                    <label className="formbold-form-label formbold-form-label-2">
                    </label>
                    <div className="flex flex-wrap formbold--mx-3">
                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Box Number
                          </label>
                          <input
                            type="text"
                            name="box_number"
                            id="box_number"
                            placeholder="Enter Box Number"
                            className="formbold-form-input"
                            value={formData.box_number}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                  

                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            SIM Number 
                          </label>
                          <input
                            type="tel"
                            name="sim_number"
                            id="sim_number"
                            placeholder="Enter SIM Number"
                            className="formbold-form-input"
                            value={formData.sim_number}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Control Number
                          </label>
                          <input
                            type="text"
                            name="control_number"
                            id="control_number"
                            placeholder="Enter Control Number"
                            className="formbold-form-input"
                            value={formData.control_number}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Retailer ID 

                          </label>
                          <input
                            type="text"
                            name="retailer_code"
                            id="retailer_code"
                            placeholder="Enter Retailer ID"
                            className="formbold-form-input"
                            value={formData.retailer_code}
                            onChange={handleChange}
                            autoComplete='off'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
              
                  <div className="search-store-buttons">
                    <button className="search-store-button" type="submit" disabled={disable}><i class="fa fa-search"></i> Search</button>
                    {
                      dataTable && (
                        <button className="search-store-button" type="button" onClick={handleClear1}>
                          Clear
                        </button>
                      )
                    }
                  </div>
                </form>
                {dataTable && (
                 <div className="data-dummy-table">
                 <DataTable
                   title=""
                   columns={columns}
                   data={retailerData}
                   pagination
                   paginationComponentOptions={paginationComponentOptions}
                   selectableRows
                   onSelectedRowsChange={handleChanges}
                   clearSelectedRows={toggledClearRows}
                   selectableRowDisabled={rowDisabledCriteria}
                   customStyles={customStyles}
                 />
               </div>
                )}


                {allocateBox && (
    
                    <button variant="gradient" className="search-store-button" style={{ backgroundColor: "#C11D6C", color: "white" }} onClick={handleAllocate}>
                      Return
                    </button>              
                )}
              </div>
            </div>
          </div>
        

        <>
        </>
      </>
    </DashboardLayout>

  )
}
export default SearchAndReturnSimStock